// import KonfigurasiPeer from "../../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigPeerTeacher"
import KonfigurasiPeer from "../../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/subpage/ConfigPeerTeacher"

export default function Home() {
  
  return (
    <KonfigurasiPeer />
  );
}
